import { computed, signal } from '@angular/core';
import { Router } from '@angular/router';
import { UiButtonComponent } from '@common/ui/frontend-shared/button';
import { AppRequestService } from '@core/frontend-shared';
import { RouterLinkResolverService } from '@core/shared/feature';
import { SceneMostRecentProgressRequest } from '@mpf/courses/shared';
import * as i0 from "@angular/core";
import * as i1 from "@core/frontend-shared";
import * as i2 from "@core/shared/feature";
import * as i3 from "@angular/router";
import * as i4 from "@common/ui/frontend-shared/card";
function CoursesContinueLastCourseComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ui-card")(1, "h3");
    i0.ɵɵtext(2, "Kurs fortsetzen");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "button", 0);
    i0.ɵɵlistener("click", function CoursesContinueLastCourseComponent_Conditional_0_Template_button_click_5_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.continueCourse());
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r1.info().course.name);
    i0.ɵɵadvance();
    i0.ɵɵproperty("label", ctx_r1.suggestionType() === "exam" ? "Zur Pr\u00FCfung" : "Weiter ansehen");
  }
}
export let CoursesContinueLastCourseComponent = /*#__PURE__*/(() => {
  class CoursesContinueLastCourseComponent {
    constructor(api, routerLinkResolvers, router) {
      this.api = api;
      this.routerLinkResolvers = routerLinkResolvers;
      this.router = router;
      this.info = signal(null, ...(ngDevMode ? [{
        debugName: "info"
      }] : /* istanbul ignore next */[]));
      this.suggestionType = computed(() => {
        const info = this.info();
        if (!info?.course) return null;
        if (info.scene) return 'scene';
        if (info.progress) {
          if (info.progress.showAsCompleted) return null;
          return 'exam';
        }
      }, ...(ngDevMode ? [{
        debugName: "suggestionType"
      }] : /* istanbul ignore next */[]));
      this.visible = computed(() => this.suggestionType() !== null, ...(ngDevMode ? [{
        debugName: "visible"
      }] : /* istanbul ignore next */[]));
      api.sendRequest(SceneMostRecentProgressRequest, {}).subscribe(response => {
        if (response.course) {
          this.info.set(response);
        }
      });
    }
    continueCourse() {
      const type = this.suggestionType();
      const info = this.info();
      if (type === 'scene') {
        const link = this.routerLinkResolvers.resolveRouterLink('frontend', 'SceneItem', {
          course: info.course,
          sceneId: info.scene.id
        });
        this.router.navigate(link);
      } else if (type === 'exam') {
        const link = this.routerLinkResolvers.resolveRouterLink('frontend', 'ExamItem', info.course);
        this.router.navigate(link);
      }
    }
    static {
      this.ɵfac = function CoursesContinueLastCourseComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CoursesContinueLastCourseComponent)(i0.ɵɵdirectiveInject(i1.AppRequestService), i0.ɵɵdirectiveInject(i2.RouterLinkResolverService), i0.ɵɵdirectiveInject(i3.Router));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: CoursesContinueLastCourseComponent,
        selectors: [["courses-continue-last-course"]],
        decls: 1,
        vars: 1,
        consts: [["uiButton", "", 3, "click", "label"]],
        template: function CoursesContinueLastCourseComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵconditionalCreate(0, CoursesContinueLastCourseComponent_Conditional_0_Template, 6, 2, "ui-card");
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.visible() ? 0 : -1);
          }
        },
        dependencies: [UiButtonComponent, i4.UiCardComponent],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return CoursesContinueLastCourseComponent;
})();